import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  success: false,
  error: '',
  nurses: [],
  page: 0,
  hasPrev: false,
  total_pages: 0,
  total_result: 0,
}

const nurseSlice = createSlice({
  name: 'getNurseUserSlice',
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      return { ...state, loading: action.payload, error: '' }
    },

    setSuccess: (state) => {
      return { ...state, success: true, loading: false, error: '' }
    },
    setNurse: (state, action) => {
      return {
        ...state,
        loading: false,
        hasNext: action.payload.hasNext,
        hasPrev: action.payload.hasPrev,
        total_pages: action.payload.total_pages,
        total_result: action.payload.total_result,
        page: action.payload.page,
        nurses: action.payload.data,
        error: '',
      }
    },

    getNurse: () => {},

    createNurse: (state, action) => {
      return { ...state, loading: false, success: true }
    },

    setUpdatedNurse: (state, action) => {
      return {
        ...state,
        loading: false,
        nurses: [...state.nurses, action.payload],
      }
    },

    setStatusUpdatedNurse: (state, action) => {
      return {
        ...state,
        loading: false,
        nurses: [...state.nurses, action.payload],
      }
    },

    setChangeNurseStatus: () => {},

    setUpdateNurseIndex: (state, action) => {
      return {
        ...state,
        loading: false,
        nurses: [...state.nurses].map((nurse, index) =>
          index === action.payload.index ? action.payload.data : nurse,
        ),
      }
    },

    setError: (state, action) => {
      return { ...state, error: action.payload, loading: false }
    },
  },
})

export const {
  setLoading,
  setSuccess,
  getNurse,
  setNurse,
  setUpdatedNurse,
  setChangeNurseStatus,
  createNurse,
  setError,
  setUpdateNurseIndex,
} = nurseSlice.actions
export default nurseSlice.reducer
